<h1 class="sr-only"><span>NOSOTROS SOMOS SORTEO ANÁHUAC MAGNO 2026</span></h1>

<section class="about  banner-padding">
    <div class="container">
        <div class="row sub-headers-inside">

            <div class="col-12 text-center my-auto">
                <div class="overlap-signature header-inside">

                    <span class="letter"> <span class="signature-text">¡Nosotros somos</span></span>
                    <h2 class="main-text">Sorteo Anáhuac!</h2>
                </div>
                 <p>#SORTEOANÁHUACSOMOSTODOS</p>
            </div>


        </div>
    </div>
</section>

<section class="content-about">
    <div class="container overlay-container">
        <div class="row justify-content-center">

            <div class="col-md-4" data-aos="fade-up">
                <div class="capsule-item">
                    <div class="img-circle">
                        <img src="/assets/images/sorteo2026/persona1.png" alt="Objetivo">
                    </div>
                    <div class="capsule-text">
                        <p>
                            Sorteo Anáhuac tiene como <strong>objetivo</strong> generar
                            <strong>recursos</strong> que se destinen de forma íntegra al
                            <strong>programa de becas</strong> y
                            <strong>desarrollo de infraestructura</strong> de la Red de
                            Universidades Anáhuac.
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-md-4" data-aos="fade-up" data-aos-delay="200">
                <div class="capsule-item">
                    <div class="img-circle">
                        <img src="/assets/images/sorteo2026/persona2.png" alt="Misión">
                    </div>
                    <div class="capsule-text">
                        <p>
                            La <strong>misión</strong> fundamental de nuestra
                            institución, ser una comunidad universitaria que 
                            <strong>contribuye e impulsa</strong> el proceso
                            de <strong>formación integral</strong> de las personas.
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-md-4" data-aos="fade-up" data-aos-delay="400">
                <div class="capsule-item">
                    <div class="img-circle">
                        <img src="/assets/images/sorteo2026/persona3.png" alt="Recursos">
                    </div>
                    <div class="capsule-text">
                        <p>
                            Sorteo Anáhuac tiene como <strong>objetivo</strong> generar
                            <strong>recursos</strong> que se destinen de forma íntegra al 
                            <strong>programa de becas</strong> y <strong>desarrollo de
                            infraestructura</strong> de la Red de Universidades Anáhuac.
                        </p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<!-- <section class="stc-valores">
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-5 col-12 my-auto text-center">
                <h2>
                    NUESTROS
                    <span class="d-md-block">
                        VALORES
                    </span>
                </h2>
            </div>
            <div class="col-xl-7 col-12 text-center my-auto"
                id="slider-valores">
                <ngx-slick-carousel class="carousel"
                    #slickModal="slick-carousel" [config]="slideConfig2">
                    <div ngxSlickItem
                        *ngFor="let slide of slides; let i = index"
                        class="slide">

                        <div>
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-12 my-auto">
                                        <img src="{{slide.img}}"
                                            class="img-fluid"
                                            alt="{{slide.place}}">
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </ngx-slick-carousel>
            </div>
        </div>
    </div>
</section> -->
<section class="valores">
    <div class="container">
        <div class="row justify-content-center">
            <h3 class="my-5">
                NUESTROS VALORES
            </h3>
        </div>
    </div>
</section>


<section class="valores2 py-5">
    <div class="container">
        <div class="row justify-content-center g-3"> <div class="col-6 col-md-4 col-lg-2">
                <div class="valor-card shadow-sm">
                    <img src="/assets/images/sorteo2026/icon1.png" alt="transparencia" class="img-fluid">
                    <h3>Transparencia</h3>
                </div>
            </div>

            <div class="col-6 col-md-4 col-lg-2">
                <div class="valor-card shadow-sm">
                    <img src="/assets/images/sorteo2026/icon2.png" alt="integridad" class="img-fluid">
                    <h3>Integridad</h3>
                </div>
            </div>

            <div class="col-6 col-md-4 col-lg-2">
                <div class="valor-card shadow-sm">
                    <img src="/assets/images/sorteo2026/icon3.png" alt="austeridad" class="img-fluid">
                    <h3>Austeridad</h3>
                </div>
            </div>

            <div class="col-6 col-md-4 col-lg-2">
                <div class="valor-card shadow-sm">
                    <img src="/assets/images/sorteo2026/icon4.png" alt="compromiso" class="img-fluid">
                    <h3>Compromiso</h3>
                </div>
            </div>

            <div class="col-6 col-md-4 col-lg-2">
                <div class="valor-card shadow-sm">
                    <img src="/assets/images/sorteo2026/icon5.png" alt="honestidad" class="img-fluid">
                    <h3>Honestidad</h3>
                </div>
            </div>

        </div>
    </div>
</section>